(function () {
  function init(root) {
    if (!root) return;
    var modal = root.querySelector('[data-video-modal]');
    var trigger = root.querySelector('[data-video-trigger]');
    var closers = root.querySelectorAll('[data-video-close]');
    var bgVideo = root.querySelector('.hm-bg-video');

    function playEmbed(iframe) {
      if (!iframe) return;
      var src = iframe.getAttribute('data-embed-src') || iframe.getAttribute('src') || '';
      var isYouTube = /youtube\.com|youtu\.be/.test(src);
      var isVimeo = /vimeo\.com/.test(src);
      var sep = src.includes('?') ? '&' : '?';
      var next = src;
      if (isYouTube) next = src + sep + 'autoplay=1&mute=0&playsinline=1&rel=0';
      else if (isVimeo) next = src + sep + 'autoplay=1&muted=0&autopause=0&playsinline=1';
      else next = src + sep + 'autoplay=1';
      iframe.setAttribute('src', next);
    }

    function playNative(v) {
      if (!v) return;
      try {
        v.muted = false;
        v.volume = 1;
        v.playsInline = true;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    function pauseNative(v) {
      if (v && v.pause) v.pause();
    }

    function open() {
      if (!modal) return;
      modal.hidden = false;
      if (bgVideo && bgVideo.pause) bgVideo.pause();
      var iframe = modal.querySelector('iframe[data-embed-src]');
      if (iframe) playEmbed(iframe);
      var video = modal.querySelector('video[data-modal-video]');
      if (video) playNative(video);
    }

    function close() {
      if (!modal) return;
      modal.hidden = true;
      var iframe = modal.querySelector('iframe[data-embed-src]');
      if (iframe) {
        var src = iframe.getAttribute('data-embed-src');
        iframe.setAttribute('src', src);
      }
      var video = modal.querySelector('video[data-modal-video]');
      if (video) pauseNative(video);
      if (bgVideo && bgVideo.play) bgVideo.play().catch(function () {});
    }

    if (trigger) trigger.addEventListener('click', open);
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.classList.contains('hm-backdrop')) close();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) close();
    });
    closers.forEach(function (el) { el.addEventListener('click', close); });

    if (bgVideo) {
      bgVideo.muted = true;
      bgVideo.playsInline = true;
      bgVideo.play().catch(function () {});
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) bgVideo.play().catch(function () {});
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[id^="HeroMedia-"]').forEach(function (el) {
      if (el.dataset.hmInit) return;
      el.dataset.hmInit = '1';
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail) return;
    var el = document.getElementById('HeroMedia-' + e.detail.sectionId);
    if (el && !el.dataset.hmInit) {
      el.dataset.hmInit = '1';
      init(el);
    }
  });
})();
